const MILLISECONDS_PER_DAY = 86_400_000;

/** Calendar date in the operator's IANA timezone, independent of the host's UTC day. */
export function calendarDateInTimeZone(date: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    timeZone,
    year: 'numeric',
  }).formatToParts(date);
  const value = (type: 'year' | 'month' | 'day') =>
    parts.find((part) => part.type === type)?.value ?? '';
  return `${value('year')}-${value('month')}-${value('day')}`;
}

export function browserCalendarTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function toUtcCalendarDay(date: Date) {
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

/**
 * Returns whole UTC calendar days until expiry. Expired dates clamp to zero; missing and invalid
 * values return null so callers can use the shared empty-value presentation.
 */
export function getDaysLeft(expiry: string | null | undefined, now = new Date()): number | null {
  if (!expiry) return null;
  const expiryDate = new Date(expiry);
  if (Number.isNaN(expiryDate.getTime()) || Number.isNaN(now.getTime())) return null;

  const daysLeft = (toUtcCalendarDay(expiryDate) - toUtcCalendarDay(now)) / MILLISECONDS_PER_DAY;
  return Math.max(0, daysLeft);
}
